import { render } from "./ChatLayout.vue?vue&type=template&id=5713fb3e"
import script from "./ChatLayout.vue?vue&type=script&lang=js"
export * from "./ChatLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__